import slideUp from './slide-up';

/**
 * Hides the mobile menu with a slide-up animation.
 *
 * This function removes the active class from the element and triggers a slide-up animation on the menu.
 *
 * @param {HTMLElement} el - The element that triggers the hide action.
 * @param {HTMLElement} menu - The menu element to hide.
 * @param {Object} params - Configuration parameters.
 * @param {number} params.mobileSpeed - The speed of the slide-up animation.
 * @param {Object} itemParams - Item-specific parameters.
 * @param {Function} itemParams.activeItemClass - A function that returns the active item class.
 * @returns {void}
 */
export default function mobileHide(el, menu, params, itemParams) {
  if (!el || !menu || !params || !itemParams) {
    console.error('Invalid arguments provided to mobileHide');
    return;
  }

  const activeClass = itemParams.activeItemClass();
  if (typeof activeClass !== 'string') {
    console.error('activeItemClass function did not return a string');
    return;
  }

  el.classList.remove(activeClass.slice(1));
  slideUp(menu, params.mobileSpeed);
}
